import { GlobalStore } from '@highlight/ipc'

/**
 * What incognito does, in one line. Shared because two menus explain it — the
 * Sidepanel's toolbar toggle and the Mini's submenu — and they were drifting
 * copies of the same sentence.
 */
export const INCOGNITO_EXPLAINER = "Screen and audio capture is paused. Highlight won't record or process any content."

export const isIncognitoModeEnabled = (): boolean => {
  return GlobalStore.general().get<boolean>('incognitoMode', false)
}

export const durationUntilMorning = (): number => {
  const now = new Date()
  const target = new Date(now)
  target.setHours(6, 0, 0, 0)
  if (target <= now) target.setDate(target.getDate() + 1)
  return target.getTime() - now.getTime()
}
